import { Button, CircularProgress } from "@mui/material";
import React from "react";

const CustomSubmitButton = (props) => {
    const { type, onSubmit, btnTitle, loading, sx = {} , disabled} = props
    return (
        <>
            <Button
                sx={{
                    width: "100%",
                    borderRadius: "15px",
                    background: "linear-gradient(148.97deg, #0C2C50 0%, #450F5B 100%)",
                    padding: "8px 12px",
                    fontWeight: "500",
                    fontSize: "18px",
                    color: "white",
                    textTransform: "capitalize",
                    "&:hover": {
                        background: "linear-gradient(148.97deg, #0C2C50 0%, #450F5B 100%)",
                        color: "white",
                    },
                    "&:disabled":{
                        background: "#ddd",
                        color: "white",
                    },
                    ...sx,
                    fontFamily: "Outfit",
                }}
                type={type}
                onClick={onSubmit}
                disabled={disabled}
            >
                {loading ? (
                    <CircularProgress
                        size={32}
                        sx={{
                            color: "#fff",
                        }}
                    />
                ) : (
                    btnTitle
                )}
            </Button>
        </>
    );
};

export default CustomSubmitButton;
